import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { DialogModule } from "primeng/dialog";

interface infoDescription {
  paragraphs: string[];
}

@Component({
  selector: "app-month-info-modal",
  standalone: true,
  imports: [DialogModule],
  templateUrl: "./month-info-modal.component.html",
  styleUrl: "./month-info-modal.component.scss",
})
export class MonthInfoModalComponent implements OnInit {
  @Input() infoType: "HI1" | "HI2" = "HI1";
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  title: string = "";
  hi1Description: infoDescription = {
    paragraphs: ["The HI1 record always depicts the schedule of the current month."],
  };

  hi2Description: infoDescription = {
    paragraphs: [
      "The HI2 record delineates two distinct effective periods.",
      "From the 1st to the 15th contractual day, the HI2 record reflects the schedule of the preceding month.",
      "Starting from the 16th of the month, the HI2 record pertains to the schedule of the upcoming month.",
    ],
  };
  hiDescription: infoDescription = this.hi1Description;
  monthCardDataDescription: infoDescription = {
    paragraphs: [
      "The month card displays PROJ from both the HI record, and the active plan.",
      "When displaying next month's data, if the HI2 record is in the PENDING state, the month card will display plan data for all fields that are not PENDING.",
    ],
  };

  ngOnInit(): void {
    this.title = this.infoType === "HI1" ? "Current Month" : "Next Month";
    this.hiDescription = this.infoType === "HI1" ? this.hi1Description : this.hi2Description;
  }

  closeDialog(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
